import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const FirstPage: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5352 11.9983L17 16.6676L15.4539 18L11 11.9978L15.4541 6L16.9998 7.33308L13.5352 11.9983Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M7 18L7 6L9 6L9 18L7 18Z" />
  </SvgIcon>
)
